var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"aria-hidden":"true"}},[_c('svg',{attrs:{"height":_vm.width,"width":_vm.width,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none","stroke":"none"}}),_vm._v(" "),_c('keep-alive',[_c(("i" + _vm.name),{tag:"component"})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe6a8fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/Icon.vue
// module id = HLbT
// module chunks = 0 1 3 4 5